<template>
  <!-- Main layout -->
  <main>
    <mdb-parallax
    src="https://cdn.pixabay.com/photo/2016/11/14/00/48/print-1822374_1280.jpg"
    height="500"
    factor="1.3">
      <mdb-mask overlay="" flexCenter>
        <mdb-row class="mb-5 pb-5 text-center">
          <mdb-col md="12" xl="12" class="mx-auto">
            <h1 class="display-5 font-weight-bold">Consolturia de Gratis!</h1>
          </mdb-col>
        </mdb-row>
      </mdb-mask>
    </mdb-parallax>
   
  </main>
  <!-- Main layout -->
</template>

<script>
  import { mdbParallax, mdbMask, mdbRow, mdbCol } from 'mdbvue';
  export default {
    components: {
      mdbParallax,
      mdbMask,
      mdbRow,
      mdbCol
    }
  }
</script>